<template>
  <div>
    <div class="md-layout md-gutter">
      <div class="md-layout-item md-size-50">
        <md-field :class="!checkArea(typeInfo.area) ? 'md-invalid' : ''">
          <label for="area">{{ $t("typeInfo.areaFire") }} (ha)</label>
          <md-input type="number" step="0.01" name="area" v-model="typeInfo.area" />
          <span class="md-error">{{ $t("error.errorRange") }} (0-99999)</span>
        </md-field>
      </div>
      <div class="md-layout-item md-size-50">
        <md-field :md-counter="false" :class="!checkYear(typeInfo.event_year) ? 'md-invalid' : ''">
          <label for="year">{{ $t("typeInfo.year") }}</label>
          <md-input type="number" name="year" v-model="typeInfo.event_year" maxlength="4" />
          <span class="md-error">{{ $t("error.errorRange") }} (1900-2100)</span>
        </md-field>
      </div>
      <div class="md-layout-item md-size-100">
        <toggle-buttons :btnList="frequencyList" :label="$t('typeInfo.frequency')" @btnValue="getFrequency" :editTB="typeInfo.frequency" />
      </div>
      <div class="md-layout-item md-size-100">
        <toggle-buttons :btnList="effectList" :label="$t('typeInfo.effect')" @btnValue="getEffect" :editTB="typeInfo.effect" />
      </div>
    </div>

    <error-dialog :show="error" :text="$t('error.dataCheck')" @closeError="error = false" />
  </div>
</template>

<script>
import ToggleButtons from '@/components/ToggleButtons'
import ErrorDialog from '@/components/ErrorDialog'

import EventBus from '@/event-bus'
import { getDomain } from '@/assets/scripts/domainsManager'
import { checkPercentage, checkYear, checkArea, normalize } from '@/assets/scripts/formatData'

const FREQUENCY = 'forest_fire_frequency'
const EFFECT = 'forest_fire_effect'

export default {
  name: 'ForestFire',
  components: {
    ToggleButtons,
    ErrorDialog
  },
  data: () => ({
    typeInfo: {
      area: null,
      event_year: null,
      frequency: '',
      effect: ''
    },
    frequencyList: {},
    effectList: {},
    edit: false,
    checkPercentage: checkPercentage,
    checkYear: checkYear,
    checkArea: checkArea,
    error: false
  }),
  mounted () {
    this.$store.state.plot.id === null ? this.edit = false : this.edit = true

    EventBus.$on('save', () => {
      this.saveData()
    })

    this.setLists()

    if (this.edit) {
      this.typeInfo = this.$store.state.plot.typeInfo // ref to store
    }
  },
  methods: {
    saveData: function () {
      if (this.checkData()) {
        if (this.typeInfo.area !== null) this.typeInfo.area = normalize(this.typeInfo.area, 2)
        this.edit ? this.$emit('typeInfo', null) : this.$emit('typeInfo', this.typeInfo)
      } else {
        this.error = true
      }
    },

    setLists: function () {
      getDomain(FREQUENCY).then(data => {
        this.frequencyList = data[this.$i18n.locale]
      })
      getDomain(EFFECT).then(data => {
        this.effectList = data[this.$i18n.locale]
      })
    },

    getFrequency: function (value) {
      this.typeInfo.frequency = value
    },

    getEffect: function (value) {
      this.typeInfo.effect = value
    },

    checkData: function () {
      return checkArea(this.typeInfo.area) && checkYear(this.typeInfo.event_year)
    }
  }
}
</script>

<style lang="scss" scoped>
  @import '@/assets/style/arcadia_theme.scss';
</style>
